import './Arena.css';
import './Ranks/Rank.css';
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import React, {useState} from "react";
import StartPvP from "./SartPvP/StartPvP";
import Dailys from "./Dailys/Dailys";
import Rank from "./Ranks/Rank";
import RankReward from "./Ranks/RankReward";
import Champions from "./Ranks/Champions";
import SeasonProgress from "./SeasonProgress/SeasonProgress";
import CardVeryBig from "../../card/CardVeryBig";
import ArenaRewards from "./ArenaRewad/ArenaRewards";

function ArenaComponent() {


    const [showRankReward, setShowRankReward] = useState(false);
    const [showRankChampions, setShowRankChampions] = useState(false);

    return <div className={'main-popup-container'}>

        <ButtonCloseMainPopup/>

        <div className={'arenaTitle'}>
            <div className={'arenaTitleText'}>Arena</div>
        </div>
        <CardVeryBig/>

        <Dailys/>
        <StartPvP/>

        <div className={'arenaVerticalMidSeparator'}></div>

        <Rank/>
        <div className={'rankButtonContainer'}>
            <div className={'rankButtonChampions'} onClick={() => {
                setShowRankChampions(true);
            }}></div>
            <div className={'rankButtonReward'} onClick={() => {
                setShowRankReward(true);
            }}></div>
        </div>
        {(showRankReward || showRankChampions) ?
            <div className={'rankPopupContainer'} onClick={() => {
                setShowRankReward(false);
                setShowRankChampions(false);
            }}>

                {(showRankReward) ?
                    <RankReward/> : <div></div>
                }

                {(showRankChampions) ?
                    <Champions/> : <div></div>
                }

            </div>
            : <div></div>
        }

        <div className={'arenaHorizontalMidSeparator'}></div>

        <SeasonProgress/>

        <ArenaRewards />

    </div>
}

export default ArenaComponent
